import { Component, HostListener, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { GamingUtility } from '../../gaming/gaming.utility';
import { sortState } from "../../shared/utility/config";
import * as _ from 'underscore';
import { TranslateService } from '@ngx-translate/core';
import { EmitterService } from '../../services/emitter.service';

@Component({
  selector: 'app-lobby-game-result-page',
  templateUrl: './lobby-game-result-page.component.html',
  styleUrls: ['./lobby-game-result-page.component.scss']
})
export class LobbyGameResultPageComponent implements OnInit {

  @Input() gameGroupDetails;
  @Input() liveTableData;
  @Input() favItemObj;
  onScrollLoadGames = false;
  start;
  end;
  selectedGames: any;
  footerHeight;
  tagId;
  sort;
  allGamesArray = [];
  providerId;
  activeLobbyBannerTitle;
  gameGroupFromParams;
  allGamesPage = false;
  @Output() lobbyTitle = new EventEmitter();
  @HostListener("window:scroll", ["$event"]) onWindowScroll() {
    if (this.selectedGames && this.selectedGames.length !== 0) {
      this.onScroll();
    }
  }

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private gamingUtils: GamingUtility,
    private translateService: TranslateService,
    private emitterService: EmitterService
  ) { 
    this.router.events.subscribe((evt) => {
      if(evt instanceof NavigationEnd) {
        this.setParamsMap();
        this.getGameDetails();
      }
    });
  }

  ngOnInit(): void {
    this.setParamsMap();
    this.getGameDetails();
  }

  /* Fetching Params and queryparams */ 
  setParamsMap() {
    let paramMap = this.activatedRoute.snapshot;
    this.allGamesPage = false;
    if(window.location.pathname.includes("casino/allgames")) {
      this.allGamesPage = true;
    }
    this.providerId = paramMap.queryParams["providerId"];
    this.tagId = paramMap.queryParams["tagId"];
    this.sort = paramMap.queryParams["sort"];
  }

  getGameDetails() {
    if(this.tagId) {
      this.selectedGames = _.filter(this.gameGroupDetails, gameGroup => {
        return gameGroup['tagList'].indexOf(this.tagId) !== -1;
      })
      if(this.selectedGames.length > 0) {
        this.activeLobbyBannerTitle = this.translateService.instant('gamePlayCategories.' + this.tagId);
        this.lobbyTitle.emit(this.activeLobbyBannerTitle);
      }
      this.setMetaTitle(this.tagId);
    } else if(this.providerId) {
      this.selectedGames = _.filter(this.gameGroupDetails, gameGroup => {
        return gameGroup['vendorCode'].indexOf(this.providerId) !== -1;
      });
      if(this.selectedGames.length > 0) {
        this.activeLobbyBannerTitle = this.selectedGames[0].vendorDisplayName;
        this.lobbyTitle.emit(this.activeLobbyBannerTitle);
      }
      this.setMetaTitle(this.providerId);
    } else if(this.allGamesPage) {
      this.selectedGames = this.gameGroupDetails;
      this.activeLobbyBannerTitle = this.translateService.instant("gamingComp.gaming16");
      this.lobbyTitle.emit(this.activeLobbyBannerTitle);
      this.setMetaTitle('allGames');
    }
    if(this.sort) {
      this.sortGames(this.sort);
    }
    this.initializeLazyLoading();
  }

  /*Function for initally starting the lazy loader by showing 18 items and leaving the lazy loader job to scroll function from next time*/
  initializeLazyLoading() {
    if(this.selectedGames && this.selectedGames.length !== 0){
      this.start = 0;
      this.end = 17;
      this.allGamesArray = [];
      if (this.selectedGames.length < this.end) {
        this.end = this.selectedGames.length - 1;
      }
      for (let i = this.start; i <= this.end; i++) {
        this.allGamesArray.push(this.selectedGames[i]);
      }
      this.start = this.end + 1;
    }
  }

  /*
    Function for capturing scroll event and starting lazy loading then onwards.Lazy loading happens when scroller touches footer.
    Lazy Loading continues on the filtered data, if filter is already there.
  */
  onScroll() {
    let footerWrapRef = document.querySelector('.footer_wrap') as HTMLElement;
    let footerRegBlockRef = document.querySelector('.footerRegBlock') as HTMLElement;
    let footerWrapValue = footerWrapRef ? footerWrapRef.offsetHeight : 0;
    let footerRegBlockValue = footerRegBlockRef ? footerRegBlockRef.offsetHeight : 0;
    this.footerHeight = footerWrapValue + footerRegBlockValue;

    if((window.pageYOffset + window.innerHeight) >= (document.body.scrollHeight - this.footerHeight) && this.selectedGames) {
      if (this.selectedGames.length > this.start) {
        this.onScrollLoadGames = true;
      } else {
        this.onScrollLoadGames = false;
      }
      setTimeout(() => {
        if(this.onScrollLoadGames) {
          if (this.selectedGames.length >= this.start + 17) {
            this.end = this.start + 17;
          } else {
            this.end = this.end + this.selectedGames.length - this.start;
          }
          for (let i = this.start; i <= this.end; i++) {
            this.allGamesArray.push(this.selectedGames[i]);
          }
          this.start = this.end + 1;
          this.onScrollLoadGames = false;
        }
      }, 100)
    }
  }

  /* Function for sorting games. Click 1,2,3 resemble first second and third clicks */
  sortGames(status) {
    let tempArr = [];
    this.gamingUtils.copyGameObject(tempArr, this.gameGroupDetails);
    switch (status){
      case sortState.asc:
        this.selectedGames = this.gamingUtils.ascendingSort(tempArr);
        break;
      case sortState.desc:
        this.selectedGames = this.gamingUtils.descendingSort(tempArr);
        break;
      case sortState.none:
        this.resetSort();
    }
  }
  
  /*Function to reset sorting on 3rd click*/
  resetSort() {
    /*While reseting the sort of 3rd click, if provider is not there then show all games as it was before, else dont do anything, provider filtered data will be shown*/
    this.gamingUtils.copyGameObject(this.selectedGames, this.gameGroupDetails);
  }

  setMetaTitle(metaName) {
    this.emitterService.broadCastUpdateMetaInfo({
      title: this.translateService.instant('seo.' + metaName +'MetaTitle'), 
      keywords: this.translateService.instant('seo.' + metaName +'MetaKeyWords'), 
      description:  this.translateService.instant('seo.' + metaName +'MetaDescription')
    });
  }
}
